import { Routes } from '@angular/router';
import { UploadComponent } from '../../pages/eCert/upload/upload.component';
import { FillInComponent } from '../../pages/eCert/fill-in/fill-in.component';
import { CustomerComponent } from '../../pages/eCert/customer/customer.component';
import { CertificatesComponent } from '../../pages/eCert/certificates/certificates.component';
import { UpdateCustomerDetailsComponent } from 'src/app/pages/eCert/update-customer-details/update-customer-details.component';
import { CustomerManagementResetPasswordComponent } from 'src/app/pages/customer-management/customer-management-reset-password/customer-management-reset-password.component';
import { SupportComponent } from 'src/app/pages/support/support.component';



export const CustomerLayoutRoutes: Routes = [
  { path: 'upload/:id', component: UploadComponent, title: 'Upload Certificate - CVT Web' },
  { path: 'customer', component: CustomerComponent, title: 'Customer Details - CVT Web' },
  { path: 'customer/reset-password', component: CustomerManagementResetPasswordComponent, title: 'Reset Password - CVT Web' },
  { path: 'certificates', component: CertificatesComponent, title: 'Certificates - CVT Web' },
  { path: 'fill/:id', component: FillInComponent, title: 'Fill-In Certificate - CVT Web' },
  { path: 'update-customer-details', component: UpdateCustomerDetailsComponent, title: 'Update Customer Details - CVT Web' },
  { path: 'support', component: SupportComponent, data: { showBackButton: true }, title: 'Support - CVT Web' }
];
